import { makeStyles } from '@mui/styles';
const expressionsOfInterestSideStyles = makeStyles(({ palette: { text: { secondary }, }, }) => ({
    sectionTitle: {
        color: secondary,
        fontWeight: 'bold',
        marginBottom: 10,
    },
    content: {},
}), { name: 'Common_ExpressionsOfInterestSide' });
export default expressionsOfInterestSideStyles;
//# sourceMappingURL=expressionsOfInterestSide.styles.js.map